import React from 'react';
import { cn } from '@/lib/utils';

const sizes = {
  sm: 'h-5 w-5 border-2',
  md: 'h-8 w-8 border-2',
  lg: 'h-12 w-12 border-3',
};

export default function LoadingSpinner({ size = 'lg', message = 'Carregando...', className }) {
  return (
    <div className={cn('flex flex-col items-center justify-center py-16', className)}>
      <div className={cn('animate-spin rounded-full border-primary/30 border-t-primary', sizes[size])} />
      {message && <p className="text-sm text-slate-500 mt-4">{message}</p>}
    </div>
  );
}
